import {ObjectDTO} from "../object-dto";

export class EquipementANettoyerPmsDto extends ObjectDTO {
  libelle: string;
  image: File;
}
